import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(VExpandTransition, [
        _setup.chips.length
          ? _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "px-4" },
                  [
                    _c(
                      VChipGroup,
                      { attrs: { column: "", "active-class": "primary" } },
                      _vm._l(_setup.chips, function (chip, i) {
                        return _c(
                          VChip,
                          {
                            key: i,
                            attrs: {
                              close: "",
                              "close-icon": "ui-icon-close-circle",
                              color: "primary",
                              "text-color": "bg-gray-0",
                            },
                            on: {
                              "click:close": function ($event) {
                                return _setup.handleCloseChip(chip.key)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "text-truncate" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_setup.t(chip.name, _setup.options)) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      VChip,
                      {
                        attrs: {
                          "close-icon": "ui-icon-close-circle",
                          color: "bg-primary",
                          "text-color": "primary",
                        },
                        on: {
                          click: function ($event) {
                            return _setup.handleCloseAll()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Сбросить все", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(VDivider, { staticClass: "mt-4" }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }